import { Avatar, AvatarProps } from "@mui/material";
import useDictionaries from "features/dictionaries/useDictionaries";

export interface ProgramVariantAvatarProps extends AvatarProps {
  programVariantId?: number;
}

const ProgramVariantAvatar: React.FC<ProgramVariantAvatarProps> = ({
  programVariantId,
  sx,
  ...props
}) => {
  const { resolveOption } = useDictionaries();

  const programVariant = resolveOption("variants", programVariantId);

  return (
    <Avatar
      sx={{
        backgroundColor: programVariant?.program?.color,
        color: theme =>
          programVariant?.program?.color
            ? theme.palette.getContrastText(programVariant?.program?.color)
            : undefined,
        ...sx,
      }}
      {...props}
    >
      {programVariant?.program?.code || " "}
    </Avatar>
  );
};

export default ProgramVariantAvatar;
